module.exports = "<a href=\"#\" id=\"js_up\" class=\"boton-subir\" title=\"Ir arriba\">\r\n    <i class=\"fa fa-rocket\" aria-hidden=\"true\"></i>\r\n</a>"